import { LeadsPagination } from "./leads";

// Mirrors ContactRequest.STATUS_CHOICES on the backend — keep the two in sync,
// since update_request rejects any value not in that set.
export const REQUEST_STATUS_OPTIONS: [string, string][] = [
  ['new', 'New'],
  ['in_progress', 'In Progress'],
  ['replied', 'Replied'],
  ['closed', 'Closed'],
  ['spam', 'Spam'],
];

export const REQUEST_STATUS_LABELS: Record<string, string> = Object.fromEntries(REQUEST_STATUS_OPTIONS);

export type ContactRequestType = {
  id: number;
  name: string;
  contact: string;
  description: string;
  types: string;
  coupon: string;
  business_name: string;
  phone: string;
  attachment: string | null;
  attachment_name: string | null;
  status: string;
  status_display: string;
  is_read: boolean;
  is_replied: boolean;
  replied_at: string | null;
  replied_by: string | null;
  assigned_to_id: number | null;
  assigned_to: string | null;
  lead_id: number | null;
  internal_notes: string;
  ip_address: string | null;
  referer: string | null;
  created_at: string | null;
  updated_at: string | null;
};

export type ContactRequestHistoryEntry = {
  action: string;
  action_display: string;
  user: string;
  changes: Record<string, { old: any; new: any }> | null;
  metadata: Record<string, any> | null;
  created_at: string;
};

export type ContactRequestsPagination = LeadsPagination;

export type ContactRequestsQueryParams = {
  page?: number;
  per_page?: number;
  search?: string;
  status?: string;
  is_read?: boolean;
  is_replied?: boolean;
  types?: string;
  date_from?: string;
  date_to?: string;
  sort?: 'recent' | 'oldest';
};

export type ContactRequestUpdateFields = {
  status?: string;
  note?: string;
  is_read?: boolean;
  replied?: boolean;
  internal_notes?: string;
  assigned_to_id?: number | null;
  lead_id?: number | null;
};

// Fired by RequestsPage whenever it learns a fresh unread count, so the
// sidebar badge doesn't lag behind until the next full reload.
export const REQUESTS_UNREAD_EVENT = 'requests:unread-count';
